import React from "react";
import PqrsdLanding from "../pqrsd/PqrsdLanding";

export default function LayoutPqrsdLanding() {
  return <PqrsdLanding />;
}
